import {
  TopUpCreditAccountDocument,
  type TopUpCreditAccountInput,
} from "@/__generated__/graphql";
import { useMutation } from "@apollo/client";

export const useTopUpCreditAccountMutation = () => {
  const [mutate, result] = useMutation(TopUpCreditAccountDocument, {
    update(cache) {
      cache.evict({ fieldName: "invoicesByFilters" });
      cache.gc();
    },
  });

  const topUpCreditAccount = async (input: TopUpCreditAccountInput) => {
    return mutate({
      variables: { input },
    });
  };

  return {
    topUpCreditAccount,
    ...result,
  };
};
